import React from 'react';
import { LabeledInput } from './Fields';

export type WorkflowIdempotencyConfig = {
  enabled: boolean;
  scope_namespace: string;
  scope_key_fields: string[];
};

interface Props {
  workflowKey: string;
  value: WorkflowIdempotencyConfig;
  onChange: (next: WorkflowIdempotencyConfig) => void;
}

export default function WorkflowIdempotencyCard({ workflowKey, value, onChange }: Props) {
  const wk = String(workflowKey ?? '').trim();
  const defaultNamespace = wk ? `workflow_run:${wk}` : 'workflow_run:<workflow_key>';

  return (
    <div className="pac-glass rounded-md p-3 space-y-3">
      <h4 className="text-sm font-semibold text-neutral-200">Workflow-run idempotency</h4>

      <label className="flex items-center gap-2 text-sm text-neutral-200">
        <input
          type="checkbox"
          className="accent-emerald-500"
          checked={value.enabled}
          onChange={(e) => onChange({ ...value, enabled: e.target.checked })}
        />
        Enable deterministic run scope
      </label>

      <div className={value.enabled ? '' : 'opacity-60 pointer-events-none select-none'}>
        <LabeledInput
          label="Scope namespace"
          value={value.scope_namespace}
          placeholder={defaultNamespace}
          onChange={(v) => onChange({ ...value, scope_namespace: v })}
          description="If left blank, the publisher will default to workflow_run:<workflow_key>."
        />

        <div className="mt-3 text-[11px] leading-snug text-neutral-500">
          Select “Scope” checkboxes in the Inputs table to choose key fields.
        </div>
      </div>
    </div>
  );
}
